import Invoice from '../../common/models/Invoice.ts';
import Driver from '../types/Driver.ts';
import PdfPageWithText from '../types/PdfPageWithText.ts';
import PdfProcessedPage from '../types/PdfProcessedPage.ts';
import PdfTextTest, { StringAtIndexTest } from '../types/PdfTextTest.ts';
import { compute_pdf_line_items, compute_pdf_tests } from '../pdf_parser.ts';
import { stamp } from '../pdf_writer.ts';
import PdfLineItem from '../types/PdfLineItem.ts';
import _ from 'lodash';

export default class extends Driver {
    constructor() {
        super()
    }

    parse_project_NaN(pdf_text_contents: string[]): string {   
        const tests = [
            {
                "string": "ORDER",
                "elements_to_skip": 2
            } as StringAtIndexTest,
            {
                "string": "NUMBER",
                "elements_to_skip": 4
            } as StringAtIndexTest,
        ]
        
        let pdf_tests = {
            "first_string": 'CUSTOMER',
            "tests": tests,
            "elements_to_skip_to_return": 6
        } as PdfTextTest

        return compute_pdf_tests(pdf_text_contents, pdf_tests) ?? ""
    }
    
    parse_invoice_NaN(pdf_text_contents: string[]): string {
        const tests = [
            {
                "string": "NUMBER",
                "elements_to_skip": 2
            } as StringAtIndexTest
        ]

        let pdf_tests = {
            "first_string": 'INVOICE',
            "tests": tests,
            "elements_to_skip_to_return": 4
        } as PdfTextTest
    
        return compute_pdf_tests(pdf_text_contents, pdf_tests) ?? ""
    }

    parse_invoice_line_items(pdf_text_contents: object): PdfLineItem[] | null {
        // return null
        // console.log(pdf_text_contents)
        let quantities_with_postion = _.chain(pdf_text_contents.items)
            .filter((content) => {
                return content.transform[4] > 300
                    && content.transform[4] < 350
                    && content.transform[5] > 110
                    && content.transform[5] < 465
            })
            .groupBy((content) => {
                return content.transform[5]
            })
            .map((contentGroup) => {
                return {
                    "y": contentGroup[0].transform[5],
                    "text": contentGroup
                        .map((contentGroupItem) => contentGroupItem.str)
                        .join("")
                }
            })
            .sortBy("y")
            .reverse()
            .value()
                
        console.log("quantities_with_postion", quantities_with_postion)
        const row_Ys = quantities_with_postion.map((quantity_with_postion: object) => quantity_with_postion.y)

        const quantities: number[] = quantities_with_postion.map((quantity_with_postion) => parseInt(quantity_with_postion.text))

        const ship_quantities: number[] = _.chain(pdf_text_contents.items)
            .filter((content) => {
                return content.transform[4] > 350 
                    && content.transform[4] < 400
                    && content.transform[5] > 110
                    && content.transform[5] < 465
            })
            .groupBy((content) => {
                return content.transform[5]
            })
            .map((contentGroup) => {
                return parseInt(
                    contentGroup
                        .map((contentGroupItem) => contentGroupItem.str)
                        .join("")
                )
            })
            .reverse()
            .value()

        let part_names: string[] = _.chain(pdf_text_contents.items)
            .filter((content) => {
                return content.transform[4] > 5
                    && content.transform[4] < 300
                    && content.transform[5] > 110
                    && content.transform[5] < 465
            })
            .groupBy((content) => {
                return content.transform[5]
            })
            .map((contentGroup) => {
                return {
                    "y": contentGroup[0].transform[5],
                    "text": contentGroup
                        .map((contentGroupItem) => contentGroupItem.str)
                        .join("")
                }
            })
            .sortBy("y")
            .reverse()
            .groupBy((text_position) => {
                for (let i = 0; i < row_Ys.length; i++) {
                    if ((i + 1) >= row_Ys.length) {
                        return row_Ys[row_Ys.length - 1]
                    } else if (text_position.y <= Math.ceil(row_Ys[i]) && text_position.y > row_Ys[i + 1]) {
                        return row_Ys[i]
                    }
                }

                return row_Ys[0]
            })
            .map((text_positions) => {
                let texts = text_positions
                    .map((text_position) => text_position.text.trim())
                    .filter((text) => !text.startsWith("*"))
                return texts.join(" ")
            })
            .reverse()
            .value()

        
        let unit_prices_and_units_of_measure: string[] = _.chain(pdf_text_contents.items)
            .filter((content) => {
                return content.transform[4] > 420
                    && content.transform[4] < 520
                    && content.transform[5] > 110
                    && content.transform[5] < 465
            })
            .groupBy((content) => {
                return content.transform[5]
            })
            .map((contentGroup) => {
                return contentGroup
                    .map((contentGroupItem) => contentGroupItem.str)
                    .join("")
            })
            .reverse()
            .value()

        const line_prices: number[] = _.chain(pdf_text_contents.items)
            .filter((content) => {
                return content.transform[4] > 520
                    && content.transform[4] < 620
                    && content.transform[5] > 110
                    && content.transform[5] < 465
            })
            .groupBy((content) => {
                return content.transform[5]
            })
            .map((contentGroup) => {
                return parseFloat(
                    contentGroup
                        .map((contentGroupItem) => contentGroupItem.str)
                        .join("")
                        .replace("$", "")
                        .replace(",", "")
                )
            })
            .reverse()
            .value()

        const units_of_measure: string[] = unit_prices_and_units_of_measure.map((unit_price_and_unit_of_measure) => unit_price_and_unit_of_measure.split("/")[1])
        const unit_prices: number[] = unit_prices_and_units_of_measure.map((unit_price_and_unit_of_measure) => parseFloat(unit_price_and_unit_of_measure.split("/")[0].replace("$", "").replace(",", "")))

        return row_Ys.map((row, index) => {
            return {
                line_number: index + 1,
                part_name: part_names[index],
                part_description: "",
                quantity: quantities[index],
                quantity_shipped: ship_quantities[index],
                quantity_back_ordered: quantities[index] - ship_quantities[index],
                unit_of_measure: units_of_measure[index],
                price_per_unit: unit_prices[index],
                line_item_total: line_prices[index]
            } as PdfLineItem
        })
    }
    
    parse_total(pdf_text_contents: string[]): number | null {
        const tests = [
            {
                "string": "DUE",
                "elements_to_skip": 2
            } as StringAtIndexTest
        ]

        let pdf_tests = {
            "first_string": 'AMOUNT',
            "tests": tests,
            "elements_to_skip_to_return": 6
        } as PdfTextTest
    
        const total = compute_pdf_tests(pdf_text_contents, pdf_tests)
        return this.parse_money_string(total) ?? null
    }

    check(pdf_text_contents: string[]): boolean {
        const tests = [
            {
                "string": " ",
                "elements_to_skip": 1
            } as StringAtIndexTest,
            {
                "string": "ELECTRIC",
                "elements_to_skip": 2
            } as StringAtIndexTest
        ]
        
         let pdf_tests = {
            "first_string": 'ECHO',
            "tests": tests,
            "elements_to_skip_to_return": 3
        } as PdfTextTest

        return compute_pdf_tests(pdf_text_contents, pdf_tests) === " "
    }

    parse_pages(pages: PdfPageWithText[]): PdfProcessedPage[] {
        console.log("EHCO!!")
        return pages.map((page: PdfPageWithText) => {
            return new PdfProcessedPage({
                page_number: page.page_number,
                vendor: 'Echo',
                // line_items: [],
                line_items: this.parse_invoice_line_items(page.text_contents_full),
                project_NaN: this.parse_project_NaN(page.text_contents),
                invoice_NaN: this.parse_invoice_NaN(page.text_contents),
                total: this.parse_total(page.text_contents)
            })
        })
    }

    async stamp_invoices(invoices: Invoice[]): Promise<Invoice[]> {
        const x_coordinate = 96
        const y_coordinate = 800

        for (const index in invoices) {
            const invoice = invoices[index]
            if (invoice.pdf_bytes === null) {
                continue
            }
            
            const stamped_pdf_bytes = await stamp(x_coordinate, y_coordinate, invoice.invoice_information, invoice.pdf_bytes)
            invoices[index].stamped_pdf_bytes = stamped_pdf_bytes
            invoices[index].stamp_x = x_coordinate
            invoices[index].stamp_y = y_coordinate
        }

        return invoices  
    }
}
